import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceWorkOrderFeatureDefinition } from '@digiwall/goliath-products/config';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'service-work-orders' },
  {
    path: 'service-work-orders',
    title: 'Doc::Menu:ServiceWorkOrderDocs',
    canMatch: [ServiceWorkOrderFeatureDefinition],
    data: {
      breadcrumb: {} as BreadcrumbDefinition,
    },
    loadChildren: () =>
      import('./service-work-order-doc/service-work-order-doc.module').then(
        m => m.ServiceWorkOrderDocModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceWorkOrderRoutingModule {}
